import { useEffect, useRef, useCallback } from "react";

// import { envConfig } from "../config";
// import {
//   initializeAuthHandlerAtom,
//   isAuthenticatedAtom,
//   authTokensAtom,
// } from "@pineseed/workspace/state/auth";
import { isAppInitializedAtom, initializeAppAtom } from "@pineseed/workspace/state/initialization";
// import type { BrandConfig } from "@pineseed/workspace/config/brand";
import type { PSAuthConfig } from "@pineseed/gui/types/auth";
import type { EdgeAuthClient } from "@pineseed/auth";

/**
 * App-level initialization hook for Edge Edge - SINGLE POINT OF TRUTH
 *
 * CRITICAL: This is the ONLY place where handlers, networks, auth, or any
 * system initialization should occur. Components MUST NOT initialize anything.
 *
 * Architecture:
 * - Idempotent: Safe to call multiple times (React Strict Mode)
 * - Centralized: All app-level systems initialized here
 * - Edge-specific: Handles JWT exchange and session validation
 */
export function useAppInitialization({
  authConfig,
  // edgeAuth,
  validateSession,
  exchangeJWTForApiKey,
//   fetchMessages,
//   connectWebSocket,
}: {
  authConfig: PSAuthConfig;
  // edgeAuth: EdgeAuthClient;
  validateSession: () => Promise<boolean>;
  exchangeJWTForApiKey: () => Promise<boolean>;
//   fetchMessages: () => Promise<void>;
//   connectWebSocket: () => void;
}) {
//   const store = useStore();
//   const [, initializeAuthHandler] = useAtom(initializeAuthHandlerAtom);
//   const [, initializeApp] = useAtom(initializeAppAtom);
//   const [isAuthenticated] = useAtom(isAuthenticatedAtom);
//   const [authTokens] = useAtom(authTokensAtom);
  const appInitializationRef = useRef<boolean>(false);
  
  // Don't get auth headers immediately - only when session is ready

  // Phase 1: App-level initialization
  useEffect(() => {
    if (appInitializationRef.current) return;
    appInitializationRef.current = true;

    const initialize = async () => {
      console.log("🚀 Starting Edge app initialization...");
    //   console.log("VITE_ORPC_ENABLED:", envConfig.protocol.orpcEnabled);

      // Update document title
      // document.title = `${brandConfig.name} - ${brandConfig.tagline}`;

    //   // Initialize auth handler
    //   await initializeAuthHandler(authConfig as PSAuthConfig);
    //   console.log("✅ Edge auth handler initialized");

    //   // Initialize app-level systems
    //   await initializeApp({
    //     store: store,
    //   });
      
    //   console.log("✅ Edge app initialization complete");
      
      // Try to validate existing session first
      let sessionReady = await validateSession();
      if (!sessionReady) {
        // Exchange JWT for API key if authenticated
        sessionReady = await exchangeJWTForApiKey();
        if (!sessionReady) {
          console.warn('JWT exchange failed, skipping WebSocket connection');
          return;
        }
      }
      
      // // Only proceed if we have a valid session
      // if (sessionReady) {
      //   await fetchMessages();
      //   connectWebSocket();
      // }

    //   console.log("✅ Edge app initialization complete");
    };

    initialize();
  }, [
    authConfig,
    validateSession,
    exchangeJWTForApiKey,
    // fetchMessages,
    // connectWebSocket,
  ]);

//   // Phase 2: Handle authentication state changes
//   useEffect(() => {
//     if (isAuthenticated) {
//         console.log("✅ Edge app authentication state changed");
//     //   fetchMessages();
//     //   connectWebSocket();
//     }
// //   }, [fetchMessages, connectWebSocket, isAuthenticated]);
//   }, [isAuthenticated]);

//   // Phase 3: Handle JWT token changes
//   useEffect(() => {
//     if (isAuthenticated && authTokens?.accessToken) {
//       exchangeJWTForApiKey();
//     }
//   }, [isAuthenticated, authTokens?.accessToken, exchangeJWTForApiKey]);
}
